// A user's picture in a circle, or a person icon without one. Decorative: the name is always beside it.
// The API stores GIFs with only their first frame, so nothing here animates. Sizes are classes (site.css), since
// the CSP allows no inline styles.
export function Avatar({url, size, className}: { url?: string, size: 'sm' | 'lg', className?: string }) {
    const classes = `avatar avatar-${size} flex-shrink-0 ${className ?? ''}`;
    if (url) {
        return <img src={url} alt="" className={classes}/>;
    }
    return <i className={`bi bi-person-circle avatar-placeholder ${classes}`} aria-hidden="true"></i>;
}
